"use strict";
const util = require("js/util.js");
import { BoundPopupFor } from "./bound_popup.js";

class FollowPopupLinks extends BoundPopupFor {
    constructor() {
        super();
    }

    connectedCallback() {
        if (this.__firstRun == false) {
            const closePopup = (() => {
                this.close();
            }).bind(this);

            util.followInternalCardLinks(this.parentElement, this, closePopup);

            let showMoreButtons = this.parentElement.querySelectorAll(".show-more-button");
            if (showMoreButtons) {
                console.log("Add event to show more buttons");
                showMoreButtons.forEach((each) => {
                    each.addEventListener("click", () => {
                        // remove the hidden class to show them again
                        this.parentElement
                            .querySelectorAll("ldc-card-relation.hidden")
                            .forEach((revision) => revision.classList.remove("hidden"));

                        // the "show more" button is not necessary, so remove all of them
                        showMoreButtons.forEach((o) => o.classList.add("hidden"));
                    });
                });
            }

            super.connectedCallback();
        }
    }

    close() {
        console.log("FollowPopupLinks close called");
        this.__setPreventOpening(true);
        this.classList.add("disabled");
        setTimeout(() => this.__setPreventOpening(false), 200);
    }
}

customElements.define("ldc-popup-follow-links", FollowPopupLinks);

export { FollowPopupLinks };
